import * as os from 'os'
import * as path from 'path'
import { DEFAULT_KUBE_CONFIG } from 'yam-operator/constants'
import { EngineConfig } from 'yam-operator/settings.d'
import { IApplicationModel, K8SResourceType } from 'yam-types'

export const ENGINE_BASE_PATH = path.join(os.homedir(), ".yam")

export const DEFAULT_SERVER_ADDR = "https://yam.plus"

export const DEFAULT_ENGINE_CONFIG: EngineConfig = {
  serverConf: {
    url: DEFAULT_SERVER_ADDR,
    token: ''
  },
  clientConf: {
    kubeConfig: DEFAULT_KUBE_CONFIG(),
    contextPatternMapping: {},
    kubeConfigFilePatternMapping: {},
    telemetry: true,
    lockType: "k8s",
    planStoreType: "local-file"
  },
  plugins: []
}

export const DEFAULT_CHECK_STATUS_SECONDS = 180

export const DEFAULT_APP_FILE_NAME = 'app.yaml'

export const DEFAULT_APP_YAML: IApplicationModel = {
  metadata: {
    app: '',
    namespace: ''
  },
  prepare: [],
  config: [],
  deploy: {
    type: K8SResourceType.Deployment,
    replicas: 2,
    version: '',
    containers: [
      {
        name: '',
        image: ''
      }
    ]
  }
}
